import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, ArrowRight, Paperclip } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader } from "@/components/public/Bits";
import { Reveal } from "@/components/Reveal";

function formatDate(d) {
  try { return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }); }
  catch { return d; }
}

export default function News() {
  const [news, setNews] = useState(null);
  useEffect(() => { api.get("/public/news").then((r) => setNews(r.data)).catch(() => setNews([])); }, []);

  return (
    <div>
      <PageHeader eyebrow="Announcements" title="News" subtitle="Official news and announcements." kanji="空手道" />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        {news === null ? (
          <Loader />
        ) : news.length === 0 ? (
          <EmptyState icon={Newspaper} kanji="空手道" title="No news yet" message="Official announcements will be published here." testid="news-empty" />
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {news.map((n, i) => (
              <Reveal key={n.id} delay={Math.min(i * 0.05, 0.3)}>
                <Link to={`/news/${n.id}`} data-testid={`news-card-${n.id}`}
                  className="group flex h-full flex-col rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-ukf-gold hover:shadow-md">
                  <div className="flex items-center justify-between">
                    <p className="font-mono text-xs font-semibold uppercase tracking-wider text-ukf-gold-dark">{formatDate(n.date)}</p>
                    {n.media?.length > 0 && <Paperclip className="h-4 w-4 text-slate-400" />}
                  </div>
                  <h3 className="mt-3 font-serif text-xl font-semibold text-ukf-ink transition-colors group-hover:text-ukf-red">{n.title}</h3>
                  <span className="mt-auto pt-5 inline-flex items-center gap-1 text-sm font-semibold text-ukf-red">
                    Read more <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
